import { Button, Container, Stack, Text, Title } from '@mantine/core';
import { ROOT_SECTION } from 'shared-base';
import classes from './PageLogin.module.css';
import { FinePrint, Google, Image, ImageTop, Wrapper } from './PageLogin.style';

export type PageLoginProps = {
  palettes: IPalettes;
  onClick: () => void;
};

export function PageLogin(props: PageLoginProps) {
  return (
    <Wrapper className='PageLogin-wrapper' data-testid='PageLogin-wrapper'>
      <div className={classes.root}>
        {/* Right side image */}

        {/* Left side login */}
        <div className={classes.left}>
          <Container size='xs'>
            <Stack align='center' spacing='lg'>
              <div className={classes.logoPlaceholder} />

              <Title order={2} className={classes.title}>
                Welcome to Sloyd.ai
              </Title>

              <Text size='sm' c='dimmed' align='center'>
                Get started - it's free. No credit card needed.
              </Text>

              <Button
                fullWidth
                leftSection={<Google src={'/google.svg'} />}
                variant='light'
                color='dark'
                radius='md'
                size='md'
                onClick={props.onClick}
              >
                Continue with Google
              </Button>
              <FinePrint>
                By proceeding, you agree to the{' '}
                <a href='https://www.sloyd.ai/terms-of-use' target='_blank'>
                  Terms of Service
                </a>{' '}
                and{' '}
                <a href='https://www.sloyd.ai/privacy-policy' target='_blank'>
                  Privacy Policy
                </a>
              </FinePrint>
            </Stack>
          </Container>
        </div>
        <div className={classes.right}>
          <Image>
            <ImageTop src={`${ROOT_SECTION('special')}/special_front.png`} />
          </Image>
        </div>
      </div>
    </Wrapper>
  );
}

export default PageLogin;
